import customerService from 'Services/CustomerService'

// initial state
const state = {
  customers: []
}

const defaults = {
  storeValue: true
}

// getters
const getters = {
  customer: state => reference => state.customers.find(customer => customer.reference === reference)
}

const actions = {
  filterCustomers: ({ commit }, { context, filterContext, options }) => {
    options = Object.assign({}, defaults, options)

    const { request, cancelToken } = customerService.getAll(context, filterContext, options)

    const promise = new Promise((resolve, reject) => {
      request.then(result => {
        if (options.storeValue) {
          commit('setCustomers', result.data)
        }
        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })

    return { promise, cancelToken }
  },

  getCustomers: ({ dispatch }, { context }) => {
    return dispatch('filterCustomers', { context }).then(({ promise }) => promise.then(result => result.data))
  },

  getCustomer: ({ commit }, { context, reference, options }) => {
    options = Object.assign({}, defaults, options)

    return new Promise((resolve, reject) => {
      customerService.get(context, reference, options).then(result => {
        if (options.storeValue) {
          commit(state.customers.some(item => item.reference === result.data.reference) ? 'updateCustomer' : 'setCustomer', result.data)
        }

        resolve({ customer: result.data, version: result.version })
      }).catch(error => {
        reject(error)
      })
    })
  },

  addCustomer: ({ commit }, { context, customer, options }) => {
    options = Object.assign({}, defaults, options)

    return new Promise((resolve, reject) => {
      customerService.add(context, customer, options).then((result) => {
        if (options.storeValue) {
          commit('setCustomer', result.data)
        }

        resolve({ customer: result.data, version: result.version })
      }).catch(error => {
        reject(error)
      })
    })
  },

  updateCustomer: ({ dispatch }, { context, reference, customer, options }) => {
    return new Promise((resolve, reject) => {
      customerService.update(context, reference, customer, options).then(() => {
        return dispatch('getCustomer', { context, reference, options }).then(result => resolve(result))
      }).catch(error => {
        reject(error)
      })
    })
  },

  deleteCustomer: ({ commit }, { context, reference, options }) => {
    return new Promise((resolve, reject) => {
      customerService.delete(context, reference, options).then(() => {
        commit('deleteCustomer', reference)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

// mutations
const mutations = {
  setCustomers (state, customers) {
    state.customers = customers
  },

  setCustomer (state, customer) {
    state.customers.push(customer)
  },

  updateCustomer (state, customer) {
    state.customers = state.customers.map(item =>
      item.reference === customer.reference ? customer : item
    )
  },

  deleteCustomer (state, reference) {
    state.customers = state.customers.filter(customer => customer.reference !== reference)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
